import React from 'react';

export default function SectionCard({ title, subtitle, action, children, padded = true, testid }) {
  return (
    <div className="ceap-card overflow-hidden" data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-800/80">
          <div>
            {title && <div className="font-display text-[15px] font-semibold text-zinc-50">{title}</div>}
            {subtitle && <div className="text-[12px] text-zinc-500 mt-0.5">{subtitle}</div>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={padded ? 'p-6' : ''}>{children}</div>
    </div>
  );
}
